module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-enterprise"
  }, [_c('header', {
    staticClass: "bar bar-nav close-popup"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-right",
    attrs: {
      "to": {}
    }
  }, [_c('span', {
    staticClass: "icon icon-down"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("单位搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup",
    on: {
      "click": _vm.valueConvey2
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchEnterprise"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchEnterprise",
      "placeholder": "单位名称"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "68px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, [_c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.filteredData), function(company, index) {
    return _c('li', {
      staticClass: "item-content",
      on: {
        "click": function($event) {
          return _vm.valueConvey(index)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner close-popup"
    }, [_c('div', {
      staticClass: "item-title",
      attrs: {
        "id": "resultsEnterprise"
      }
    }, [_vm._v("\n            " + _vm._s(company.enterpriseName) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', {
      staticClass: "badge",
      model: {
        value: (_vm.enterpriseNo),
        callback: function($$v) {
          _vm.enterpriseNo = $$v
        },
        expression: "enterpriseNo"
      }
    }, [_vm._v(_vm._s(company.enterpriseNo))])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b71ce72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnterpriseBox.vue
// module id = 1581
// module chunks = 8